import { BandIndexGridBand } from "@/components/BandIndexGridBand";
import { BandIndexTableBand } from "@/components/BandIndexTableBand";
import {
  preferredViewModeState,
  searchResultCountState,
} from "@/context/states";
import { useSearchBands } from "@/lib/api";
import Grid from "@mui/material/Grid";
import { useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

export default function BandListPage({ searchConfig, page = 0, limit = 24 }) {
  /*const { bands, isLoading, isValidating, isError } = useBandIndex(
    page * limit,
    limit,
  );*/

  const { bands, isLoading, isValidating, isError } = useSearchBands(
    searchConfig,
    page * limit,
    limit,
  );

  console.debug("loading bands", bands);

  const preferredViewMode = useRecoilValue(preferredViewModeState);
  const [searchResultCount, setSearchResultCount] = useRecoilState(
    searchResultCountState,
  );

  useEffect(() => {
    console.debug("bands", bands);

    if (bands) {
      setSearchResultCount({
        ...searchResultCount,
        bands: page * limit + bands.length,
      });
    }
  }, [bands]);

  if (isLoading) {
    return <></>;
  }

  if (preferredViewMode === "list") {
    return bands?.map((band) => (
      <Grid item xs={12} key={band.id}>
        <BandIndexTableBand band={band} href={`/musik/${band.slug}`} />
      </Grid>
    ));
  }

  if (preferredViewMode === "grid") {
    return bands?.map((band) => (
      <Grid item xs={12} sm={6} key={band.id}>
        <BandIndexGridBand band={band} href={`/musik/${band.slug}`} />
      </Grid>
    ));
  }
}
